import React from "react";
import { NavLink, useLocation } from "react-router-dom";
import { IoLogOutOutline, IoMenu } from "react-icons/io5";
import sidebar from "../../utils/sidebar";
import SidebarSubMenu from "./SidebarSubMenu";
import { useStore } from "../../store/SideStore";
import useLogout from "../../hooks/useLogout";
import useGetApi from "../../hooks/useGetApi";
import LogoImg from "../../assets/img/logo.svg";

const SideBar = () => {
    const location = useLocation();
    const isOpen = useStore((state) => state.isOpen);
    const toggleSidebar = useStore((state) => state.toggleSidebar);
    const { logout } = useLogout();
    const { allData } = useGetApi("activities/admin/orders/");

    return (
        <div
            className={`flex flex-col h-screen md:hidden bg-gray-800 text-white w-25  ${
                isOpen ? "w-[200px]" : "w-[200px]"
            } transition-all duration-300`}
        >
            {/* Header/Logo */}
            <div className="flex items-center justify-between py-4 px-3">
                <img
                    src={LogoImg}
                    alt="Logo"
                    className={`w-full object-contain transition-all duration-300 ${
                        isOpen ? "block" : "hidden"
                    }`}
                />
                {/* <button
          onClick={toggleSidebar}
          className="p-2 text-white hover:bg-gray-700 rounded-md md:hidden"
        >
          <IoMenu size={24} />
        </button> */}
            </div>

            {/* Navigation */}
            <nav className="flex flex-col flex-grow">
                <ul className="space-y-1">
                    {sidebar.map((route) =>
                        route.routes ? (
                            <SidebarSubMenu route={route} key={route.name} />
                        ) : (
                            <li key={route.name}>
                                <NavLink
                                    to={route.path}
                                    target={route?.outside ? "_blank" : "_self"}
                                    className={`flex items-center px-4 py-2 text-sm font-semibold ${
                                        location.pathname === route.path
                                            ? "bg-gray-700 text-emerald-500"
                                            : "text-white hover:bg-gray-700"
                                    }`}
                                >
                                    {route.icon && (
                                        <route.icon className="w-5 h-5 mr-3" aria-hidden="true" />
                                    )}
                                    <span className={`${isOpen ? "block" : "hidden"}`}>
                                        {route.name}
                                        {route.name === "Orders" && allData?.pending_orders > 0 && (
                                            <span className="ml-2 inline-flex items-center justify-center px-2 py-0.5 text-xs font-medium text-white bg-red-500 rounded-full">
                                                {allData.pending_orders}
                                            </span>
                                        )}
                                    </span>
                                </NavLink>
                            </li>
                        )
                    )}
                </ul>
            </nav>

            {/* Logout Button */}
            <div className="mt-auto px-4 pb-4 mlg:w-max">
                <button
                    onClick={logout}
                    className="w-full flex items-center justify-center bg-white text-black py-2 px-4 rounded-lg shadow-md hover:bg-gray-200 mlg:rounded-[4px]"
                >
                    <IoLogOutOutline className="mr-2 text-lg" />
                    <span className={`${isOpen ? "block" : "hidden"}`}>Log Out</span>
                </button>
            </div>
        </div>
    );
};

export default SideBar;
